<template>
  <div>
    <g-master name="trabajos"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              ref="master"
              :beforeSend="master.beforeSend"
              :useMultipart="true"
              @action="masterAction"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="`${master.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="HABILIDADES Y CONOCIMIENTOS"/>
      </template>
      <span slot="iconRenderer" slot-scope="{text}">
            <a-avatar @click="loadPicture(text)" v-if="! $isEmpty(text)">
              <a-icon slot="icon" type="file-image"/>
            </a-avatar>
      </span>
      <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='INACTIVO' ? 'red' : (text === 'ACTIVO' ? 'blue' : 'red')">{{text}}</a-tag>
          </span>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
              <a-textarea autoSize
                          v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Orden')">
              <a-input-number style="width: 100%"
                              v-decorator="['order', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de habilidad')"
                        :formItemConfig="fiOptions"
                        :selectedObj.sync="habilidadSeleccionada"
                        :decorator="['id_h_skill_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                        :params="id_h_skill_type">
            </g-dropdown>
          </a-col>
          <a-col v-show="habilidadEsNumber" v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Mínimo')">
              <a-input-number style="width: 100%"
                              v-decorator="['min', { rules: [{ required: habilidadEsNumber, message: 'Valor requerido'}] }]"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-show="habilidadEsNumber" v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Máximo')">
              <a-input-number style="width: 100%"
                              v-decorator="['max', { rules: [{ required: habilidadEsNumber, message: 'Valor requerido'}] }]"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-show="habilidadEsLSQL" v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Consulta SQL')">
              <a-textarea style="width: 100%"
                          autoSize
                          v-decorator="['sql_query', { rules: [{ required: habilidadEsLSQL, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
              <a-checkbox v-decorator="['status', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Subir icono')">
              <a-upload
                name="avatar"
                list-type="picture-card"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                style="color: red">
                <div v-if="imageUrl">
                  <img :src="imageUrl" alt="avatar" style="width: 200px; height: 200px;"/>
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    Icono
                  </div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="NIVEL DE HABILIDAD" key="1">
        <skill-job-level v-if="idSkill" :id_skill="idSkill" :id_evaluation="id_evaluation"></skill-job-level>
        <span v-else>Seleccione una habilidad para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="PARÁMETROS" key="2">
        <skill-param-item v-if="idSkill" :id_skill="idSkill"></skill-param-item>
        <span v-else>Seleccione una habilidad para ver más.</span>
      </a-tab-pane>
    </a-tabs>
    <a-modal @ok="() => {this.expandImg = false}" @cancel="cancelImgRender" :footer="null" width="400px"
             v-model="expandImg" title="Icono">
      <a-spin :spinning="loadingImg">
        <a-card hoverable style="width: auto">
          <img
            slot="cover"
            :src="imgRender"
          />
        </a-card>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        habilidadSeleccionada: {},
        habilidadEsNumber: false,
        habilidadEsLSQL: false,
        id_h_skill_type: {h_lookup_type: 'TIPO_HABILIDAD'},
        imageUrl: '',
        expandImg: false,
        imgRender: null,
        loadingImg: false,
        tipoObjetivo: {
          h_lookup_type: 'TIPO_OBJETIVO_EVALUACION_'
        },
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            data.id_level = this.id_level
            return data
          },
          endpoint: 'skill',
          tableSetup: {
            customSlots: ['estadoRenderer', 'iconRenderer'],
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'name', sorter: true},
              {title: 'Orden', dataIndex: 'order', sorter: true},
              {title: 'Tipo de habilidad', dataIndex: 'tipo_habilidad', sorter: true},
              {title: 'Mínimo', dataIndex: 'min', sorter: true},
              {title: 'Máximo', dataIndex: 'max', sorter: true},
              {title: 'Consulta SQL', dataIndex: 'sql_query', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {
                title: 'Icono',
                dataIndex: 'icon',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'iconRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'order'},
            {name: 'status', type: 'boolean'},
            {name: 'min'},
            {name: 'max'},
            {name: 'id_h_skill_type'},
            {name: 'sql_query'}
          ]
        },
        paramsT: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    props: ['id_subgroup', 'id_evaluation'],
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.imageUrl = ''
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'masterEdit':
            if (action.record.status === '1') {
              this.$refs.master.modal.form.setFieldsValue({
                status: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                status: false
              })
            }
            if (action.record.tipo_habilidad === 'NUMBER') {
              this.habilidadEsNumber = true
            } else {
              this.habilidadEsNumber = false
              this.$refs.master.modal.form.setFieldsValue({
                min: null,
                max: null
              })
            }

            if (action.record.tipo_habilidad === 'LOV SQL') {
              this.habilidadEsLSQL = true
            } else {
              this.habilidadEsLSQL = false
              this.$refs.master.modal.form.setFieldsValue({
                sql_query: null
              })
            }
            break
          case 'masterCreate':
            this.habilidadEsNumber = false
            this.habilidadEsLSQL = false
            break
        }
      },
      cancelImgRender () {
        this.imgRender = null
      },
      loadPicture (ruta) {
        this.expandImg = true
        this.loadingImg = true
        this.httpClient.getInstance().get('render_image', {
          params: {ruta: ruta},
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.imgRender = window.URL.createObjectURL(blob)
            this.loadingImg = false
          }).catch(error => {
            this.loadingImg = false
          })
      },
      beforeUpload (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
          this.$message.error('Solo puedes subir imágenes!')
          return false
        }
        const isLt2M = file.size / 1024 < 800
        if (!isLt2M) {
          this.$message.error('La imagen debe ser menor a 800 KB!')
          return false
        }
        this.master.uploads.profileFile = [file]
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.imageUrl = reader.result
        })
        reader.readAsDataURL(file)

        return false
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_subgroup_skill: this.id_subgroup
        }
      },
      idSkill () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    },
    watch: {
      habilidadSeleccionada () {
        if (this.habilidadSeleccionada.code === 'NUM') {
          this.habilidadEsNumber = true
        } else {
          this.habilidadEsNumber = false
          this.$refs.master.modal.form.setFieldsValue({
            min: null,
            max: null
          })
        }

        if (this.habilidadSeleccionada.code === 'LSQ') {
          this.habilidadEsLSQL = true
        } else {
          this.habilidadEsLSQL = false
          this.$refs.master.modal.form.setFieldsValue({
            sql_query: null
          })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Skill.vue